<template>
  <div>
    <Tracking/>
    <link href="/css/bootstrap.css" rel="stylesheet" type="text/css">
    <link href="/css/style.css" rel="stylesheet" type="text/css">
    <link href="/css/linecons.css" rel="stylesheet" type="text/css">
    <link href="/css/font-awesome.css" rel="stylesheet" type="text/css">
    <link href="/css/responsive.css" rel="stylesheet" type="text/css">
    <link href="/css/animate.css" rel="stylesheet" type="text/css">
    <link href="/fonts/avenir/avenir.css" rel="stylesheet" type="text/css">
    <div id="landing-body">

<div>

<!--Header_section-->
<header id="header_outer">
  <div class="container">
    <div class="header_section">
    <a class="res-nav_click animated wobble wow" href="#" @click="showMobileMenu=!showMobileMenu"><i class="fa-bars" style="color: #20a8d8"></i></a> 
      <div class="logo"><a href="javascript:void(0)"><img src="/img/logob.png" alt=""></a></div>
      <nav class="nav" id="nav">
        <ul class="">
          <li><a href="#top_content">Home</a></li>
		      <li><a href="#examples">Exemplos de Posts</a></li>
          <li><a href="#service">Serviços</a></li>
          <li><a href="#function">Como Funciona</a></li>
          <li><a href="#pricing">Preços</a></li>
          <li><a href="/pages/login?source=landing_page" class="learn_more3">Login</a></li>
        </ul>
      </nav>

        <nav class="nav" v-if="showMobileMenu">
          <ul class="" style="display: block; width: 100%">
            <li><a href="#top_content">Home</a></li>
            <li><a href="#examples">Exemplos de Posts</a></li>
            <li><a href="#service">Serviços</a></li>
            <li><a href="#function">Como Funciona</a></li>
            <li><a href="#pricing">Preços</a></li>
            <li><a href="/pages/login?source=landing_page">Login</a></li>
          </ul>
        </nav>



      </div>
  </div>
</header>

<!--Header_section--> 

<!--Top_content-->
<section id="top_content" class="top_cont_outer" v-bind:style="showMobileMenu ? 'margin-top: 300px;' : ''">
  <div class="top_cont_inner">
    <div class="container">
      <div class="top_content">
        <div class="row">
          <div class="col-sm-12 text-center">
            <div class="top_left_cont flipInY wow animated text-center" style="padding: 0">
              <h2>Personal/Nutri, o seu Instagram já está te trazendo clientes?</h2>
              <iframe v-id="video" style="width: 100%; height: 500px;" :src="'https://www.youtube.com/embed/' + video + '?autoplay=1'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              <p> Nessa aula, nosso parceiro <a href="https://www.instagram.com/rodrigomoutinhoo" target="_blank">@rodrigomoutinhoo</a> dá dicas valiosíssimas para você começar a mudar sua história <b>AGORA</b>.</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>

</div>

  <!-- Section: pricing --> 
  <section id="examples" class="home-section paddingbot-60" style="background-color: #fff;"> 
      <div class="container">
          <div class="row">
            <div class="col-lg-8 col-lg-offset-2">
              <div class="wow lightSpeedIn" data-wow-delay="0.1s">
              <div class="section-heading text-center">
              <h2 class="h-bold">Exemplos de posts</h2>
              <h6><b>Mais de mil posts </b> para você escolher</h6>
              </div>
              </div>
              <div class="divider-short"></div>
            </div>
          </div>
    <div class="container">
      <section class="main-section contact" id="exeamples">
          <div class="row" style="margin-bottom: 30px;">
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-1.png"> </div>
              </div>
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-2.png"> </div>
              </div>
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-3.png"> </div>
              </div>
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-4.png"> </div>
              </div>
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-5.png"> </div>
              </div>
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-6.png"> </div>
              </div>
            </div>
            <div class="row" style="margin-bottom: 30px;">
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-7.png"> </div>
              </div>
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-8.png"> </div>
              </div>
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-9.png"> </div>
              </div>
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-10.png"> </div>
              </div>
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-11.png"> </div>
              </div>
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-12.png"> </div>
              </div>
            </div>
            <div class="row" style="margin-bottom: 30px;">
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-13.png"> </div>
              </div>
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-14.png"> </div>
              </div>
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-15.png"> </div>
              </div>
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-16.png"> </div>
              </div>
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-17.png"> </div>
              </div>
              <div class="col-xs-6 col-sm-3 col-md-2 wow fadeInLeft contact-test animated" style="visibility: visible; animation-name: fadeInLeft;">
                  <div class="delay-03s animated wow  zoomIn animated" style="visibility: visible; animation-name: zoomIn;"><img src="/img/example-18.png"> </div>
              </div>
          </div>
          <div class="row">
            <div class="col-lg-12 text-center">
              <a href="#pricing" class="learn_more2">Quero conhecer</a>
          </div>
          </div>
      </section>
  </div>
  </div>
  </section>   
  


<!--Top_content--> 
  
<!--Service-->
<section  id="service">
  <div class="container">
    <h2>Serviços da plataforma</h2>
      <p class="animated fadeInDown wow topo">Saiba o que você ganha assinando o Sleeker!</p>
    <div class="service_area">
      <div class="row">
        <div class="col-lg-3">
          <div class="service_block">

            <div class="delay-03s animated wow  zoomIn"><img src="/img/icone-1.png" /> </div>
            <h3 class="animated fadeInUp wow">Templates prontos para uso</h3>
            <p class="animated fadeInDown wow">Economize tempo com diversas artes prontas para postar! Insira sua logo e pronto, é só baixar!</p>
          </div>
        </div>
		<div class="col-lg-3">
          <div class="service_block">
             <div class="delay-03s animated wow  zoomIn"><img src="/img/icone-2.png" /> </div>
            <h3 class="animated fadeInUp wow">Textos editáveis</h3>
            <p class="animated fadeInDown wow">Quer trocar o conteúdo do Sleeker ou mudar a formatação do texto? Deixe o Sleeker com a sua cara!</p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service_block ">
            <div class="delay-03s animated wow  zoomIn"><img  src="/img/icone-3.png" /> </div>
            <h3 class="animated fadeInUp wow">Produção diária de Sleekers</h3>
            <p class="animated fadeInDown wow">Escolha as artes que mais combinam com seu negócio! Nossa equipe produz novos templates diariamente!</p>
          </div>
        </div>
		
		   <div class="col-lg-3">
          <div class="service_block">

            <div class="delay-03s animated wow  zoomIn"><img src="/img/sugestao-de-legenda.png" /> </div>
            <h3 class="animated fadeInUp wow">Sugestão de Legenda</h3>
            <p class="animated fadeInDown wow">Sugestões de textos para as legendas, com indicação das fontes e hashtags. Adapte para ficar com o seu estilo!</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>
<!--Service-->


<section class="main-section functions" id="function"><!--main-section team-start-->
  <div class="container">
    <h2 class="texto-cinza">Como funciona o Sleeker?</h2>
    <h6 class="texto-cinza">Veja como você pode usar o Sleeker para turbinar suas redes sociais:</h6>

     <div class="row">
	        <div class="col-lg-2">

        </div>
        <div class="col-lg-2">
          <div class="box-functions">
          
		 
          </div>
        </div>

        <div class="col-lg-2" >
          <div class="box-functions2">
           
          </div>
        </div>

         <div class="col-lg-2">
           <div class="box-functions3">
             
          </div>

        </div>

         <div class="col-lg-2">
           <div class="box-functions4">
            
          </div>
        </div>
      </div>
	  <br><br>
	  <div class="row">
	   <div class="col-sm-2 col-sm-offset-3" style="text-align: center;">
	   <img src="/img/menina.png">
	   </div>
	   <div class="col-sm-3 ">
	   <h6 class="texto-cinza">Mantenha suas redes sociais ativas <br/> com muito mais <b style="color: #20A8D8">praticidade.</b></h6>
	    </div>
	  </div>
	  <br>
	  <div class="row">
	   <div class="col-sm-2 col-sm-offset-3" style="text-align: center;">
	   <img src="/img/equipe.png">
	   </div>
	  <div class="col-sm-3 ">
	     <h6 class="texto-cinza">Use artes feitas por profissionais <br/> para aumentar o <b style="color: #20A8D8">engajamento</b></h6>
		  </div>
	  
	   
	  </div>
	   <br>
	   <div class="row">
	   <div class="col-sm-2 col-sm-offset-3" style="text-align: center;">
	   <img src="/img/computador.png">
	   </div>
	    <div class="col-sm-3">
	     <h6 class="texto-cinza">Interaja com seu público-alvo e aumente <br/> a conversão de <b style="color: #20A8D8">clientes!</b></h6>
		</div>
	  </div>
  </div>
</section>
<!--main-section team-end-->

  <!-- Section: pricing --> 
 <!-- Section: pricing --> 
  <section id="pricing" class="home-section paddingbot-60" style="background-color: #fff;"> 
    <div class="container marginbot-50">
      <div class="row">
        <div class="col-lg-8 col-lg-offset-2">
          <div class="wow lightSpeedIn" data-wow-delay="0.1s">
          <div class="section-heading text-center">
          <h2 class="h-bold">Escolha o seu plano</h2>
          <h6>Escolha o plano que melhor se adequa ao seu orçamento.</h6>
          </div>
          </div>
          <div class="divider-short"></div>
        </div>
      </div>
    </div>
           
       <div class="container">
      
      <div class="row">

        <div class="col-sm-2 pricing-box">
          <div class="wow bounceInUp" data-wow-delay="0.1s">
          <div class="pricing-content general">
            <h2>30 Dias</h2>
            <h3><small>R$</small>29<sup>,90</sup></h3>
            <h2>R$29,90 total</h2>
            <div class="price-bottom">
              <a href="/payments" class="btn-assine">Assinar</a>
            </div>
          </div>
          </div>
        </div>

        <div class="col-sm-5 pricing-box pricing-box featured-price">
          <div class="wow bounceInUp" data-wow-delay="0.3s">
          <div class="pricing-content featured">
	          <img src="/img/coroa.png">
            <h2>90 Dias</h2>
            <h3><small>R$</small>26<sup>,60</sup><small>/mês</small> </h3>
            <h2>R$79,80 total</h2>
            <div class="price-bottom">
              <a href="/payments" class="btn-assine-featured">Assinar</a>
            </div>
          </div>
          </div>
        </div>

        <div class="col-sm-2 pricing-box">
          <div class="wow bounceInUp" data-wow-delay="0.2s">
          <div class="pricing-content general last">
            <h2>180 Dias</h2>
             <h3><small>R$</small>24<sup>,98</sup><small>/mês</small> </h3>
             <h2>R$149,88 total</h2>

            <div class="price-bottom">
               <a href="/payments" class="btn-assine">Assinar</a>
            </div>
          </div>
          </div>
        </div>

        <div class="col-sm-2">
          <div class="wow bounceInUp" data-wow-delay="0.2s">
          <div class="pricing-content">
	
            <h2>365 Dias</h2>
             <h3><small>R$</small>24<sup>,16</sup><small>/mês</small> </h3>
             <h2>R$289,92 total</h2>

            <div class="price-bottom">
               <a href="/payments" class="btn-assine">Assinar</a>
            </div>
          </div>
          </div>
        </div>
      </div>        
        
            </div>
  </section>   
  <!-- /Section: pricing -->
<footer class="footer_section" id="contact">
        <div class="container">
            <div class="footer_bottom">
                <div class="row">
                    <div class="col-sm-6 clearfix">
                        <ul class="social-link pull-left">
                            <li class="instagram"><a href="https://instagram.com/sleekerbr" target="_blank"><i class="fa-instagram"></i></a></li>
                            <!-- <li class="facebook"><a href="" target="_blank"><i class="fa-facebook"></i></a></li> -->
                        </ul>
                    </div>
                    <div class="col-sm-6 text-right">
                      <p>© Copyright 2021 Sleeker</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</div>
  </div>
</template>

    <script type="text/javascript" src="./js/jquery.1.8.3.min.js"></script>
    <script type="text/javascript" src="./js/bootstrap.js"></script>
    <script type="text/javascript" src="./js/jquery-scrolltofixed.js"></script>
    <script type="text/javascript" src="./js/jquery.easing.1.3.js"></script>
    <script type="text/javascript" src="./js/jquery.isotope.js"></script>
    <script type="text/javascript" src="./js/wow.js"></script>
    <script type="text/javascript" src="./js/classie.js"></script>
    


    <script type="text/javascript">
      $(document).ready(function(e) {
            $('.res-nav_click').click(function(){
        $('ul.toggle').slideToggle(600)	
          });	
          
      $(document).ready(function() {
    $(window).bind('scroll', function() {
            if ($(window).scrollTop() > 1) {
                $('#header_outer').addClass('fixed');
          $('#header_outer').css({"background-color": "white"})
            }
            else {
                $('#header_outer').removeClass('fixed');
            $('#header_outer').css({"background": "transparent"})
            }
        });
      
        });
        

            });	
    function resizeText() {
      var preferredWidth = 767;
      var displayWidth = window.innerWidth;
      var percentage = displayWidth / preferredWidth;
      var fontsizetitle = 25;
      var newFontSizeTitle = Math.floor(fontsizetitle * percentage);
      $(".divclass").css("font-size", newFontSizeTitle)
    }
    </script>

    <script type="text/javascript">
    $(document).ready(function(e) {
        $('#header_outer').scrollToFixed();
        $('.res-nav_click').click(function(){
            $('.main-nav').slideToggle();
            return false    
            
        });
        
    });
</script> 
<script>
    wow = new WOW(
      {
        animateClass: 'animated',
        offset:       100
      }
    );
    wow.init();
    document.getElementById('').onclick = function() {
      var section = document.createElement('section');
      section.className = 'wow fadeInDown';
	  section.className = 'wow shake';
	  section.className = 'wow zoomIn';
	  section.className = 'wow lightSpeedIn';
      this.parentNode.insertBefore(section, this);
    };
  </script> 
<script type="text/javascript">
	$(window).load(function(){
		
		$('a').bind('click',function(event){
			var $anchor = $(this);
			
			$('html, #landing-body').stop().animate({
				scrollTop: $($anchor.attr('href')).offset().top - 91
			}, 1500,'easeInOutExpo');
			/*
			if you don't want to use the easing effects:
			$('html, body').stop().animate({
				scrollTop: $($anchor.attr('href')).offset().top
			}, 1000);
			*/
			event.preventDefault();
		});
	})
</script> 



<script type="text/javascript">

   
  jQuery(document).ready(function($){     
// Portfolio Isotope
	var items = $('.carousel-inner .item');

  var idxActive = 0;
  var totalItems = items.length;


  $(items[0]).addClass('active');

  var changePost = function() {
    $(items[idxActive]).fadeOut(150,"swing",function() {
      $(items[idxActive]).removeClass('active');
      idxActive = (idxActive + 1) % totalItems;
      $(items[idxActive]).addClass('active');
      $(items[idxActive]).fadeIn(200,"linear");
    });

    setTimeout(changePost, 4000);
  };

  setTimeout(changePost, 4000);


  var container = $('#portfolio-wrap');
	

	container.isotope({
		animationEngine : 'best-available',
	  	animationOptions: {
	     	duration: 200,
	     	queue: false
	   	},
		layoutMode: 'fitRows'
	});	

	$('#filters a').click(function(){
		$('#filters a').removeClass('active');
		$(this).addClass('active');
		var selector = $(this).attr('data-filter');
	  	container.isotope({ filter: selector });
        setProjects();		
	  	return false;
	});
		
		
		function splitColumns() { 
			var winWidth = $(window).width(), 
				columnNumb = 1;
			
			
			if (winWidth > 1024) {
				columnNumb = 4;
			} else if (winWidth > 900) {
				columnNumb = 2;
			} else if (winWidth > 479) {
				columnNumb = 2;
			} else if (winWidth < 479) {
				columnNumb = 1;
			}
			
			return columnNumb;
		}		
		
		function setColumns() { 
			var winWidth = $(window).width(), 
				columnNumb = splitColumns(), 
				postWidth = Math.floor(winWidth / columnNumb);
			
			container.find('.portfolio-item').each(function () { 
				$(this).css( { 
					width : postWidth + 'px' 
				});
			});
		}		
		
		function setProjects() { 
			setColumns();
			container.isotope('reLayout');
		}		
		
		container.imagesLoaded(function () { 
			setColumns();
		});
		
	
		$(window).bind('resize', function () { 
			setProjects();			
		});

});
$( window ).load(function() {
	jQuery('#all').click();
	return false;
});
</script>

<script>

import Tracking from "./Tracking";
export default {
  name: "Landing",
  data: function() {
    return {
      showMobileMenu: false,
      video: undefined
    };
  },
  computed: {
  
  },
  methods: {
    
  },
  created: function() {
    this.video = this.$route.params.key;
  },
  components: { Tracking }
};
</script>


<style>
.margin-bot {
  margin-bottom: 30px !important;
}
</style>